import { useEffect, useRef, useState } from 'react';
export var useHorizontalScroll = function () {
    var scrollRef = useRef(null);
    var _a = useState({
        nextDisabled: false,
        previousDisabled: true,
    }), navigationControl = _a[0], setNavigationControl = _a[1];
    var lastState = useRef(navigationControl);
    useEffect(function () {
        if (scrollRef.current) {
            var el_1 = scrollRef.current;
            var controlDisabledHandler_1 = function () {
                var state = {
                    previousDisabled: el_1.scrollLeft <= 1,
                    nextDisabled: el_1.offsetWidth + el_1.scrollLeft >= el_1.scrollWidth,
                };
                if (state !== lastState.current) {
                    lastState.current = state;
                    setNavigationControl(state);
                }
            };
            var onWheel_1 = function (e) {
                if ((el_1.scrollLeft <= 1 && e.deltaY < 0) ||
                    (el_1.offsetWidth + el_1.scrollLeft >= el_1.scrollWidth &&
                        e.deltaY > 0)) {
                    return;
                }
                if (e.deltaY === 0)
                    return;
                e.preventDefault();
                el_1.scrollTo({
                    left: el_1.scrollLeft + e.deltaY,
                });
            };
            el_1.addEventListener('wheel', onWheel_1);
            el_1.addEventListener('scroll', controlDisabledHandler_1);
            return function () {
                el_1.removeEventListener('wheel', onWheel_1);
                el_1.removeEventListener('scroll', controlDisabledHandler_1);
            };
        }
    }, []);
    return { scrollRef: scrollRef, navigationControl: navigationControl };
};
